export default __webpack_public_path__ + "static/media/anambra-logo.8df005c9.jpg";